<template>
	<div class="box__container">
		<div class="box__header">
			<div class="box__header__title">
				<h2>Twitter</h2>
			</div>
		</div>
		<div class="box__body">
			<div class="box__body__subtitle">
				<p>{{ 'twitter-text' | translate | capitalize }}</p>
			</div>
			<div class="submit__content">
				<button type="submit" :disabled="true">
					{{ 'to-integrate' | translate | capitalize }}
				</button>
			</div>
			<div class="integration__twitter">
				<a href="https://www.twitter.com" target="_blank"><h5>twitter</h5></a>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'twitter',
	data() {
		return {
			successMsg: false,
			display: '',
			msg: 'Salvar',
			erro: false,
		};
	},
	computed: {
		error() {
			return this.$store.state.error;
		},
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
		errorForm(obj, field) {
			let erro = false;
			if (obj) {
				if (obj[field]) {
					erro = true;
				}
			}
			return erro;
		},
	},
};
</script>





// WEBPACK FOOTER //
// _source/javascripts/modules/integrations/twitter.vue